<template>
  <footer class="container pt-4 my-md-5 pt-md-5 border-top">
    <div class="row">
      <div class="col-12 col-md">
        <img
          class="mb-2"
          src="../assets/images/logo.png"
          alt=""
        >
        <small class="d-block mb-3 text-muted">© 2017-{{ year }}</small>
      </div>
      <div class="col-6 col-md">
        <h5 class="mt-0 text">
          Site Links
        </h5>
        <ul class="list-unstyled text-small">
          <li>
            <a
              class="text-muted"
              href="/about"
            >About ezFix'd</a>
          </li>
          <li>
            <a
              class="text-muted"
              href="#"
            >Information</a>
          </li>
          <li>
            <a
              class="text-muted"
              href="#"
            >ezFix'd repairs</a>
          </li>
          <li>
            <a
              class="text-muted"
              href="/privacy-policy"
            >Privacy Policy</a>
          </li>
        </ul>
      </div>
      <div class="col-6 col-md">
        <h5 class="mt-0">
          Contact Info
        </h5>
        <ul class="list-unstyled text-small">
          <li>Resource</li>
          <li>Phone: <a href="tel:+16042456680">(604) 245-6680</a></li>
          <li>  <a href="mailto:info@ezfixd.com">info@ezfixd.com</a></li>
          <li>
            <a
              class="text-muted"
              href="/faq"
            >FAQ Auto Repair Financing</a>
          </li>
          <li>
          Click
<a v-b-modal.modal-no-backdrop><span style="color:blue; ">here</span></a> for details.

<b-modal id="modal-no-backdrop" hide-backdrop content-class="shadow" title="0% Interest - Conditions">
  <p class="my-2">
0% Interest Plans are subject to the repair shops agreement to participate in the promotional rate.
  </p>
</b-modal>
          </li>
          <li>
            Mechanic Click Services Inc.
          </li>
        </ul>
      </div>
      <!--
      <div class="col-6 col-md">
        <h5 class="mt-0">Most asked</h5>
        <ul class="list-unstyled text-small">
          <li>What's an Auto repair loan?</li>
          <li>Is there an impact on my credit score?</li>
          <li>What information will I need to provide?</li>
        </ul>
      </div>
      -->
    </div>
    <!--  <div>-->
    <!--    &lt;!&ndash; Footer Section start &ndash;&gt;-->
    <!--    <div class="copyright-section index-footer bg-light">-->
    <!--      <p>2018-20 Copyright by OneMechanics Inc</p>-->
    <!--    </div>-->
    <!--    &lt;!&ndash; Footer Section End &ndash;&gt;-->
    <!--    &lt;!&ndash; Tap on Top &ndash;&gt;-->
    <!--    <div class="tap-top">-->
    <!--      <div>-->
    <!--        <i class="fa fa-angle-double-up"></i>-->
    <!--      </div>-->
    <!--    </div>-->
    <!--    &lt;!&ndash; Tap on Ends &ndash;&gt;-->
    <!--&lt;!&ndash;    <color/>&ndash;&gt;-->
    <!--  </div>-->
  </footer>
</template>
<script>
export default {
  name: 'Footer',
  data() {
    return {
      year: new Date().getFullYear(),
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/components/footer.vue